import React from 'react'

const StepRejected = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill="#E35E50" />
     
      <g mask="url(#mask0_193_25839)">
        <path
          d="M6 15L5 14L9 10L5 6L6 5L10 9L14 5L15 6L11 10L15 14L14 15L10 11L6 15Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export default StepRejected
